module.exports = __webpack_public_path__ + "img/contact-pic.aa7b6cf3.png";